import searchResults from "./searchResults";
import categories from "./categories";
import warninglist from "./warninglist";
import notebookUI from "./notebookUI";
import libraryUI from "./libraryUI";
import sds from "./sds/sdsSlice";

export default {
    searchResults,
    categories,
    warninglist,
    notebookUI,
    libraryUI,
    sds,
};
